<template>
    <wizard-step-card
            header="Meldung abgeschlossen!"
            :reason="_getCurrentReason"
            :btnDoneName="false"
            btn-abbort-name="Beenden"
            v-on:abbort="$emit('abbort')"
    >

        <div class="row">

            <div class="col-6 text-center">

                <h2 class="mb-4">Sie haben es geschafft!</h2>

                <check-animation> </check-animation>


                <div class="mb-4"> <b>Vielen Dank für Ihre Mitarbeit!</b> </div>
                <p style="font-size: .9em">
                    Ihre Meldung wurde unserem Kundenservice mitgeteilt und wir werden Ihren Fall schnellstmöglich bearbeiten!
                </p>


            </div>

            <div class="col-6">

                <info-header icon="fas fa-truck">
                    <template slot="titel">
                        Rücksendeschein - DPD
                    </template>

                    <template slot="leed">
                        Der Retourenschein wurde Ihnen auch per E-mail geschickt!
                    </template>
                </info-header>

                <div class="text-center center mt-4 mb-4">
                    <button :disabled="!pdfData || returnlabel.status === 'error'" @click="openReturnLabel" class="btn btn-xl btn-info">Rücksendeschein öffnen</button>
                </div>

                <div class="mt-3" style="font-size: .9em">

                    <hr>

                    <P>Bitte kleben Sie den Retourenschein auf Ihr Paket und geben Sie es in einem DPD Paketshop Ihrer Wahl ab.</p>

                    <p>Ihren nächstgelegen Paketshop finden Sie hier: <a href='https://www.dpd.com/de_privatkunden#!pickup_paketshop' target="_blank">Paketshop finden</a></p>

                </div>



            </div>

        </div>

        <div style="display: none" >
            <object ref="returnlabel" v-if="pdfData" :data="pdfData" type="application/pdf" style="width:100%;height:485px" view="fit" title="Retourenlabel">
                <a href="#">PDF laden</a>
            </object>
        </div>

    </wizard-step-card>
</template>

<script>
    import InfoHeader from '../../elements/InfoHeader'
    import WizardStepCard from '../../elements/WizardStepCard'
    import CustomerDiscription from '../../elements/CustomerDiscription'
    import CheckAnimation from '../../elements/CheckAnimation'

    export default {
        name: "finished-returnlabel",
        components: {
            InfoHeader,
            WizardStepCard,
            CustomerDiscription,
            CheckAnimation
        },

        data: () => ({
            returnlabel: false
        }),

        computed: {
            _getCurrentReason () {

                let reasonCode = this.$store.getters.getReason

                return this.$store.getters.getReasons[ reasonCode ] || 'Fehler - nicht gefunden!'
            },

            pdfData () {

                if(!this.returnlabel) return false

                return "data:application/pdf;base64," + this.returnlabel.pdfBase64String
            }
        },

        methods: {
            openReturnLabel () {

                this.$swal({
                    content: this.$refs.returnlabel,
                    className: "shippingModal"
                })
            },

            action () {

                let form = Object.assign({}, this.$store.getters.getForm)

                this.$RestClient.getReturnLabel(form.currendOrderId, form.customerId, form.reason)
                    .then(data => this.returnlabel = data)
                    .then(data => {
                        if(data.status === 'error'){
                            this.$swal({
                                title: 'Fehler',
                                text: "Der Rücksendeschein konnte nicht erstellt werden! \n\n Bitte wenden Sie sich direkt an den Kundenservice!",
                                icon: 'error'
                            })
                            return
                        }

                        form['shippingnumber'] = data.packageNr
                        this.$RestClient.sendMail2Service( form )
                    })
            },

        },

        mounted () {
            this.action()
        }
    }
</script>

<style scoped>
    .btn-info.disabled, .btn-info:disabled {
        color: #fff;
        background-color: #929292;
        border-color: #929292;
    }
</style>